var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompareFilled = function SvgCompareFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13 3a1 1 0 0 0-2 0v4.153l-5.146.858a1 1 0 0 0-.722.493l-3.605 6.308c-.131.23-.247.432-.331.653a3 3 0 0 0-.16.6C1 16.3 1 16.533 1 16.797v.213A5 5 0 0 0 11 17v-.252a4.4 4.4 0 0 0-.036-.682 3 3 0 0 0-.16-.601 4.7 4.7 0 0 0-.33-.653L7.58 9.751l8.506-1.418-2.56 4.48a4.7 4.7 0 0 0-.331.652 3 3 0 0 0-.16.6c-.036.234-.036.467-.036.731v.213A5 5 0 0 0 23 15v-.261c0-.24-.002-.457-.036-.673a3 3 0 0 0-.16-.601 4.7 4.7 0 0 0-.33-.653l-3.596-6.291A1 1 0 0 0 18.003 6H18a1 1 0 0 0-.183.017L13 6.82zm7.277 10L18 9.016 15.723 13zm-12 2L6 11.016 3.723 15z",
    clipRule: "evenodd"
  })));
};
export default SvgCompareFilled;